import React from 'react';
import {InputProps} from '../../../interfaces';
import RadioButtonRender from './RadioButtonRender';


export const RadioButton=({...props}:InputProps):JSX.Element=>{
	return <RadioButtonRender {...props}/>;
};
